import { Button as MUIButton, ButtonProps as MUIButtonProps } from '@mui/material'

import CircularProgress from '../CircularProgress'

type ButtonProps = MUIButtonProps & {
  loading?: boolean
  loadingPosition?: 'start' | 'end' | 'center'
}

function Button(props: ButtonProps) {
  const { loading = false, loadingPosition = 'end', ...other } = props

  const loadingProps = () => {
    if (!loading) return {}

    const iconIndicator = <CircularProgress color="inherit" size={16} />
    const iconPosition = loadingPosition === 'center' ? 'children' : loadingPosition + 'Icon'

    return {
      disabled: true,
      [iconPosition]: iconIndicator,
    }
  }

  return <MUIButton {...other} {...loadingProps()} />
}

export type { ButtonProps }
export { Button }

export default Button
